import { css } from 'linaria'

import { rel } from '../../styles/dimensions'


export const stateList = css`
  padding: 0 ${rel(32)}rem;
`
